import { ApiService } from 'services/api.service';

export const StoreInfoService = angular
    .module('checkout.storeInfoService', [
        ApiService
    ]).service('storeInfoService', (apiService, $q) => {
        let storeInfoCache;

        function get(refreshCache) {
            if (storeInfoCache && !refreshCache) {
                return $q.resolve(storeInfoCache);
            }
            return apiService.getStoreInformation().then((storeInfo) => {
                storeInfoCache = storeInfo;
                return storeInfo;
            });
        }

        return {
            get
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/storeInfo.service.js